'use client';

import { ReactNode } from 'react';
import { useEntitlements } from '@/utils/entitlements/client';
import { BooleanEntitlementKey } from '@/utils/entitlements/types';

export function EntitlementGate({
  entitlement,
  fallback = null,
  children
}: {
  entitlement: BooleanEntitlementKey;
  fallback?: ReactNode;
  children: ReactNode;
}) {
  const e = useEntitlements();
  const v = e[entitlement];
  return v.kind === 'boolean' && v.value ? <>{children}</> : <>{fallback}</>;
}
